import React, { useEffect, useState } from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as PenIcon } from "../../../images/penIcon.svg";

const LocatorsTable = ({ jsonData, setJsonData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(jsonData || {});
  const [editableRow, setEditableRow] = useState("");
  const [editedPrimary, setEditedPrimary] = useState([]);
  const [editedSecondary, setEditedSecondary] = useState([]);

  useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  const handleEditClick = (parameter) => {
    const { primary, secondary } = data[parameter];
    setEditableRow(parameter);
    setEditedPrimary(primary);
    setEditedSecondary(secondary);
  };

  const handleSaveClick = (parameter) => {
    const updatedData = {
      ...data,
      [parameter]: {
        primary: editedPrimary,
        secondary: editedSecondary,
      },
    };
    setJsonData(updatedData);
    setData(updatedData);
    setEditableRow("");
    navigate(location.pathname, {
      state: { ...location.state, generatedLocators: updatedData },
      replace: true,
    });
  };

  const handleCancelClick = () => {
    setEditableRow("");
  };

  return (
    <Box padding={3}>
      <TableContainer sx={{ padding: "0px", overflow: "auto", maxHeight: 400,border: "1px solid #C6C6C6", borderRadius: "4px" }}>
        <Table sx={{ border: "1px solid #C6C6C6", borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow sx={{
              border: "1px solid #C6C6C6", backgroundColor: "#1976d2",
            }}>
              <TableCell sx={{
                border: "1px solid #C6C6C6",
                backgroundColor: "#1976d2",
                color: "#ffffff",
                position: "sticky",
                top: 0, zIndex: 3, left: 0,
                minWidth: 150,
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
              >Parameter
              </TableCell>
              <TableCell sx={{
                border: "1px solid #C6C6C6",
                backgroundColor: "#1976d2",
                color: "#ffffff",
                position: "sticky",
                top: 0, zIndex: 1, minWidth: 150,
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: "12px",
              }}>
                Primary Locators
              </TableCell>
              <TableCell sx={{
                border: "1px solid #C6C6C6",
                backgroundColor: "#1976d2",
                color: "#ffffff",
                position: "sticky", top: 0, zIndex: 1,
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: "12px",
              }}>
                Secondary Locators
              </TableCell>
              <TableCell sx={{
                border: "1px solid #C6C6C6",
                backgroundColor: "#1976d2",
                color: "#ffffff",
                position: "sticky", top: 0, zIndex: 1,
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: "12px",
              }}></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Object.entries(data).map(([parameter, locators], index) => (
              <TableRow
                key={parameter}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#e3f2fd" : "#ffffff",
                  borderRight: "1px solid #C6C6C6",
                  borderLeft: "1px solid #C6C6C6",
                }}
              // style={{
              //   backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#ffffff",
              // }}
              >
                <TableCell sx={{ border: "1px solid #C6C6C6", 
                  left: 0, zIndex: 2,
                   minWidth: 150, 
                   position: "sticky",
                    backgroundColor: index % 2 === 0 ? "#e3f2fd" : "#ffffff",
                     textAlign: "center",
                    verticalAlign: "middle",
                   fontSize: "14px",
                   color: "black",
                   borderLeft:"none"
                     }}>{parameter}</TableCell>

                {/* Primary Locators */}
                <TableCell sx={{ border: "1px solid #C6C6C6", backgroundColor: index % 2 === 0 ? "#e3f2fd" : "#ffffff", minWidth: 150,
                   textAlign: "center",
                verticalAlign: "middle",
                //fontSize: "14px",
               
                 }}>
                  {editableRow === parameter ? (
                    <TextField
                      value={editedPrimary.join("\n")}
                      onChange={(e) =>
                        setEditedPrimary(e.target.value.split("\n"))``
                      }
                      
                      fullWidth
                      multiline
                      rows={3}
                        
                    />
                  ) : (
                    <Typography variant="body2" sx={{ color: "black", fontSize: "14px",lineHeight: 1.6  }}>
                      {locators.primary.map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  )}
                </TableCell>

                {/* Secondary Locators */}

                <TableCell sx={{ border: "1px solid #C6C6C6" ,
                   textAlign: "center",
                verticalAlign: "middle",
                fontSize: "14px",
              
                }}>
                  {editableRow === parameter ? (
                    <TextField
                      value={editedSecondary.join("\n")}
                      onChange={(e) =>
                        setEditedSecondary(e.target.value.split("\n"))
                      }
                      fullWidth
                      sx={{ fontSize: "14px" }}
                      multiline
                      rows={3}
                    />
                  ) : (
                    <Typography variant="body2" sx={{ color: "black" , fontSize: "14px" }}>
                      {locators.secondary.map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  )}
                </TableCell>

                <TableCell sx={{ border: "1px solid #C6C6C6" }}>
                  {editableRow === parameter ? (
                    <>
                      <IconButton
                        color="primary"
                        onClick={() => handleSaveClick(parameter)}
                      >
                        <CheckIcon />
                      </IconButton>
                      <IconButton color="secondary" onClick={handleCancelClick}>
                        <CancelIcon />
                      </IconButton>
                    </>
                  ) : (
                    <IconButton
                      color="primary"
                      onClick={() => handleEditClick(parameter)}
                      sx={{ padding: 0.5, }}
                    >
                      <PenIcon style={{ width: 18, height: 18 }} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Box>
  );
};

export default LocatorsTable;
